import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MixinFocusVisible } from '../structure/DefaultStyles';
import { MixinTruncate, TextSize85 } from '../text/Typography';

export const MixinMenuBaseLink = css`
    text-decoration: none;

    ${MixinFocusVisible}
    &:hover,
    &:focus {
        text-decoration: underline;
    }
`;

export const MixinMenuFlexContainer = css`
    display: flex;
    align-items: center;
`;

// Visually removes secondary menu content (labels, expand affordances, submenus)
// while leaving the icon rail in place.
export const MixinMenuHideContent = css`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 0px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 0px;
    padding: 0;
    margin: 0;
`;

export const MixinMenuMediaHide = css`
    @media (max-width: 500px) {
        ${MixinMenuHideContent}
    }
`;

// Collapses menu text/secondary content to an icon-only rail when an ancestor
// is marked with data-collapsed="true" (driven by the sidebar collapse toggle).
export const MixinMenuCollapseHide = css`
    [data-collapsed='true'] & {
        ${MixinMenuHideContent}
    }
`;

export const MenuActiveBar = styled.span<{ isActive: boolean; isSubActive: boolean }>`
    flex-shrink: 0;
    width: 6px;
    min-width: 6px;
    max-width: 6px;
    height: 1.75rem;
    margin: 0.25rem 0;
    background-color: ${(props) => (props.isActive ? props.theme.color.accent : 'transparent')};
`;

export const MenuTruncate = styled.span`
    ${TextSize85}
    ${MixinTruncate}
    padding: 0 0.25rem 0 0;
    ${MixinMenuMediaHide}
    ${MixinMenuCollapseHide}
    color: ${(props) => props.theme.color.textBody};
`;
